/* Epilekton product card — AJAX add-to-cart.
   Delegated submit handler. Posts to /cart/add.js with cart-drawer sections,
   then asks the cart-drawer custom element to re-render and open.
   Falls back to /cart navigation if no cart-drawer is on the page. */

(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-epi-add-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[data-epi-add-btn]');
    var textEl = form.querySelector('[data-epi-add-text]');
    var originalText = textEl ? textEl.textContent : '';
    var addingText = form.getAttribute('data-adding-text') || originalText;
    var addedText = form.getAttribute('data-added-text') || originalText;

    if (btn) btn.disabled = true;
    if (textEl) textEl.textContent = addingText;

    var drawer = document.querySelector('cart-drawer');
    var formData = new FormData(form);

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      var sectionIds = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      formData.append('sections', sectionIds);
      formData.append('sections_url', window.location.pathname);
    }

    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          // Shopify returns { status: 422, ... } on errors
          if (textEl) textEl.textContent = originalText;
          if (btn) btn.disabled = false;
          return;
        }

        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        if (textEl) textEl.textContent = addedText;
        if (btn) btn.classList.add('is-added');

        setTimeout(function () {
          if (textEl) textEl.textContent = originalText;
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('is-added');
          }
        }, 1800);
      })
      .catch(function () {
        if (textEl) textEl.textContent = originalText;
        if (btn) btn.disabled = false;
      });
  });
})();
